import { render, staticRenderFns } from "./NuevaObraSocial.vue?vue&type=template&id=06f10432"
import script from "./NuevaObraSocial.vue?vue&type=script&lang=js"
export * from "./NuevaObraSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports